import * as React from 'react'

import { observer } from 'mobx-react'

import SavedFilterLabel from '~/client/src/desktop/components/Filters/SavedFilters/SavedFiltersSelector/components/SavedFilterLabel'
import {
  Radio,
  RadioGroup,
} from '~/client/src/shared/components/shadcn-ui/radio-group'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import CustomDeliveryListFilter from '~/client/src/shared/types/CustomDeliveryListFilter'
import CustomWorkflowsFilter from '~/client/src/shared/types/CustomWorkflowFilter'

// localization: translated

interface IProps {
  activeFilterId: string
  getEntitiesCountByCustomFilter: (
    filter: CustomDeliveryListFilter | CustomWorkflowsFilter,
  ) => number
  selectCustomFilterById: (id: string) => void
  editCustomFilter: () => void
  selectCustomFilter: (value: string) => void
  customFilters: CustomDeliveryListFilter[] | CustomWorkflowsFilter[]
}

@observer
export default class SavedFiltersSelector extends React.Component<IProps> {
  public render() {
    const {
      activeFilterId,
      selectCustomFilter,
      customFilters,
      selectCustomFilterById,
      editCustomFilter,
      getEntitiesCountByCustomFilter,
    } = this.props

    if (!customFilters.length) {
      return Localization.translator.thereAreNoSavedFilters
    }

    return (
      <RadioGroup
        className="tw:flex tw:flex-col tw:gap-2"
        value={activeFilterId}
        onValueChange={selectCustomFilter}
      >
        {customFilters.map(filter => (
          <label
            key={filter.id}
            className="tw:inline-flex tw:items-center tw:gap-2 tw:cursor-pointer tw:select-none"
          >
            <Radio value={filter.id} />
            <SavedFilterLabel
              customFilter={filter}
              selectCustomFilterById={selectCustomFilterById}
              editCustomFilter={editCustomFilter}
              getEntitiesCountByCustomFilter={getEntitiesCountByCustomFilter}
            />
          </label>
        ))}
      </RadioGroup>
    )
  }
}
